import React from "react";
import useSizePercentage from "../hooks/useSizePercentage";
import RatingBar from "../misc/elements/RatingBar";
import MainStore from "../stores/MainStore";

const DetailedRatingHolder = ({ onClick, rating, name, icon, field, type }) => {
  const sizePercentage = useSizePercentage();
  const { player } = MainStore();
  function onRatingClicked(rating) {
    if (onClick) onClick(field, rating);
  }
  return (
    <div className="divColumn" style={{ width: "70%" }}>
      <div
        className="divRow"
        style={{ position: "relative", marginBottom: "5px" }}
      >
        <div
          className="textWhite"
          style={{
            zIndex: 1,
            padding: "5px",
            fontSize: sizePercentage.width < 83 ? "12px" : "16px",
          }}
        >
          {name}
        </div>
        <div
          style={{
            opacity: 0.7,
            borderRadius: ".5rem/.5rem",
            backgroundColor: "#2f2f2f",
            width: "100%",
            height: "100%",
            position: "absolute",
          }}
        />
      </div>

      <RatingBar
        image={icon}
        direction={"divRow"}
        onClick={onRatingClicked}
        rating={rating}
        imageSize={"30px"}
      />
    </div>
  );
};

export default DetailedRatingHolder;
